import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./Cart.css";
import Currency from "../../../../../../assets/images/currencyConversion.svg";
import { Box, Checkbox, CircularProgress } from "@mui/material";
import NewFormTextInput from "../../../../../../components/FormTextInput/NewFormTextInput";
import { useSearchParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import CountdownTimer from "./ExpiryTimer";
import { resetPaymentInitiate } from "../service/paymentCartSlice";
import { useDispatch } from "react-redux";
import { setToastNotification } from "../../../../../../components/ToastNotification/service/toastNotificationSlice";
import ViewLeadCardPopUp from "./PaymentSuccessfull";
import InvalidCart from "./InvalidCart";
import webformLogo from "../../../../../../assets/images/Rectangle 16.svg";

const PaymentCart = (props: any) => {
  const {
    GetPaymentCartInfoById,
    data,
    loading,
    success,
    InitiatePayment,
    paymentInitiateData,
    paymentInitiateSuccess,
    error,
  } = props;
  const dispatch = useDispatch();
  const [selectedEmi, setSelectedEmi] = useState(0);
  const [cartData, setCartData] = useState<any>();
  const [loader, setLoader] = useState(false);
  const [total, setTotal] = useState(0);
  const [emiData, setEmiData] = useState<any>();
  const [open, setOpen] = useState(false);
  const [openInvalidCart, setOpenInvalidCart] = useState(false);

  const [searchParams] = useSearchParams();

  const enquiryId = searchParams.get("enquiryId");
  const transactionId = searchParams.get("transactionId");
  const signature = searchParams.get("signature");

  useEffect(() => {
    if (enquiryId && transactionId && signature) {
      const body = {
        enquiryId,
        transactionId,
        signature,
      };
      GetPaymentCartInfoById(body);
    }
  }, [enquiryId, transactionId, signature]);

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);
    if (success) {
      setCartData(data);
      setEmiData(
        data?.emiDataOfPaymentCart?.map((d: any) => {
          return {
            ...d,
            isSelected: d?.autoSelected,
            isBalanceSelected: false,
          };
        })
        // ?.slice()
        // ?.reverse()
      );
      const result = data?.emiDataOfPaymentCart?.filter(
        (d: any) => d?.autoSelected === true
      );
      setSelectedEmi(result?.length);
    }
  }, [success]);

  useEffect(() => {
    if (paymentInitiateSuccess === true) {
      window.open(paymentInitiateData, "_blank");
      setOpen(true);
      dispatch(resetPaymentInitiate());
    }
  }, [paymentInitiateSuccess]);

  useEffect(() => {
    if (error === true) {
      setOpenInvalidCart(true);
    }
  }, [error]);

  const handleCompletePayment = () => {
    const enquiryId = searchParams.get("enquiryId");
    const transactionId = searchParams.get("transactionId");
    const signature = searchParams.get("signature");
    const data = {
      enquiryId: enquiryId,
      transactionId: transactionId,
      signature: signature,
      amount:
        emiData?.length > 0
          ? totalSelectedAmount
          : cartData?.paymentCartData?.amount,
    };
    InitiatePayment(data);
  };

  // const minSelectableEmi = emiData.filter((e: any) => e.autoSelected).length;
  // const maxSelectableEmi = emiData.length;

  // const handleEmiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let value = Number(e.target.value);

  //   // clamp value safely
  //   if (value < 0) value = 0;
  //   if (value > emiData?.length) value = emiData?.length;

  //   setSelectedEmi(value);

  //   const updatedEmiList = emiData?.map((item: any, index: any) => ({
  //     ...item,
  //     isSelected: index < value,
  //   }));

  //   setEmiData(updatedEmiList);
  // };

  const minSelectableEmi =
    emiData && emiData?.filter((e: any) => e?.autoSelected).length;
  const maxSelectableEmi = emiData && emiData?.length;

  const handleEmiChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = Number(e.target.value);

    if (Number.isNaN(value)) return;

    if (value < minSelectableEmi) {
      value = minSelectableEmi;
      dispatch(
        setToastNotification({
          message: `Minimum EMI Restricted to ${minSelectableEmi}`,
          type: "error",
          snackOpen: true,
        })
      );
    }

    if (value > maxSelectableEmi) {
      value = maxSelectableEmi;
      dispatch(
        setToastNotification({
          message: ` Maximum EMI Restricted to ${maxSelectableEmi}`,
          type: "error",
          snackOpen: true,
        })
      );
    }

    setSelectedEmi(value);

    const updatedEmiList = emiData?.map((item: any, index: number) => ({
      ...item,
      isSelected: item.autoSelected || index < value,
    }));

    setEmiData(updatedEmiList);
  };

  const handleBalanceToggle = (emiId: string) => {
    setEmiData((prev: any[]) =>
      prev.map((item) =>
        item.id === emiId
          ? { ...item, isBalanceSelected: !item.isBalanceSelected }
          : item
      )
    );
  };

  // const totalSelectedAmount = useMemo(() => {
  //   return (
  //     emiData &&
  //     emiData
  //       ?.filter((item: any) => item?.isSelected)
  //       ?.reduce((sum: number, item: any) => sum + (item.emiAmount || 0), 0)
  //   );
  // }, [emiData]);

  const totalSelectedAmount = useMemo(() => {
    if (!emiData) return 0;

    return emiData?.reduce((sum: number, item: any) => {
      if (item?.isSelected) {
        sum += item.emiAmount || 0;
      }

      if (item?.isBalanceSelected) {
        sum += item.balanceAmount || 0;
      }

      return sum;
    }, 0);
  }, [emiData]);

  function formatINR(value: any) {
    return Number(value).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  return (
    <div className="cart-container">
      {openInvalidCart === false && (
        <>
          <div className="cart-header">
            <div className="header-left">
              {cartData?.instituteDetail?.instituteLogo ? (
                <img
                  src={cartData?.instituteDetail?.instituteLogo}
                  alt="Institute Logo"
                  className="institute-logo"
                />
              ) : (
                ""
              )}
              <span className="institute-name">
                {cartData?.instituteDetail?.instituteName}
              </span>
            </div>

            <div
              style={{
                color: "rgba(29, 32, 38, 1)",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Payment History
            </div>
            {cartData ? (
              <div className="header-right">
                <span>Expires in:</span>
                <div className="expire-timer">
                  <CountdownTimer />
                </div>
              </div>
            ) : (
              <div className="header-right"></div>
            )}
          </div>

          {loader ? (
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
              }}
            >
              <PuffLoader color="#36d7b7" />
            </Box>
          ) : (
            <>
              {/* Progress Steps */}
              <div className="progress-steps">
                <div className="step completed">1</div>
                <div className="step-line"></div>
                <div className="step active">2</div>
                <div className="step-line"></div>
                <div className="step">3</div>
              </div>
              <div className="progress-heading">
                <div className="step-label">Nurture</div>
                <div className="step-lines"></div>
                <div className="step-label">Payment History</div>
                <div className="step-lines"></div>
                <div className="step-label">Checkout</div>
              </div>
              <div className="cart-grid">
                <div className="cart-left">
                  {cartData?.paymentCartData?.paymentType === "WEBFORM" ? (
                    <div className="course-card">
                      <div
                        style={{
                          borderBottom: "1px solid rgba(233, 234, 240, 1)",
                          padding: "10px",
                          color: "rgba(37, 36, 34, 1)",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Webform
                      </div>
                      <div className="course-card-details">
                        <img
                          src={
                            cartData?.webformPaymentDetail?.webformPaymentImage
                              ? `${cartData?.webformPaymentDetail?.webformPaymentImage}`
                              : webformLogo
                          }
                          className="course-icon"
                          alt="course"
                        />

                        <div className="course-info">
                          <div
                            className="student-name"
                            style={{ textTransform: "capitalize" }}
                          >
                            {cartData?.webformPaymentDetail?.webformPaymentName}
                          </div>
                          <div className="student-details">
                            Webform by:{" "}
                            {cartData?.instituteDetail?.instituteName}
                          </div>
                          <div className="course-price">
                            {cartData?.branchDetail?.currency}{" "}
                            {cartData?.enquiryDetail?.enquiryCartPaymentAmount}
                            {cartData?.enquiryDetail?.enquiryCartPaymentType ===
                              "MEMBERSHIP" &&
                              `/${cartData?.enquiryDetail?.enquirySelectedFrequency}`}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="course-card">
                      <div
                        style={{
                          borderBottom: "1px solid rgba(233, 234, 240, 1)",
                          padding: "10px",
                          color: "rgba(37, 36, 34, 1)",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Course Details
                      </div>
                      <div className="course-card-details">
                        <img
                          src={
                            cartData?.courseData?.courseImage
                              ? `${cartData?.courseData?.courseImage}`
                              : "/logo.png"
                          }
                          className="course-icon"
                          alt="course"
                        />

                        <div className="course-info">
                          <div className="student-name">
                            {cartData?.courseData?.courseName}
                          </div>
                          <div className="student-details">
                            Course by:{" "}
                            {cartData?.instituteDetail?.instituteName}
                          </div>
                          <div className="course-price">
                            {cartData?.branchDetail?.currency}{" "}
                            {cartData?.enquiryDetail?.enquiryCartPaymentAmount}
                            {cartData?.enquiryDetail?.enquiryCartPaymentType ===
                              "MEMBERSHIP" &&
                              `/${cartData?.enquiryDetail?.enquirySelectedFrequency}`}
                          </div>
                        </div>
                      </div>

                      <div className="emi-section">
                        {emiData?.length > 0 && (
                          <>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div className="student-name">Emi Details</div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                Select no of EMI's :
                                <div style={{ width: "80px" }}>
                                  <NewFormTextInput
                                    type="number"
                                    value={selectedEmi}
                                    onChange={handleEmiChange}
                                    minValue={minSelectableEmi}
                                    maxValue={maxSelectableEmi}
                                  />
                                </div>
                              </div>
                            </div>

                            <div
                              style={{
                                height: "200px",
                                overflowY: "scroll",
                                marginTop: "10px",
                              }}
                            >
                              {emiData?.map((d: any, index: number) => {
                                return (
                                  <div
                                    key={index}
                                    style={{
                                      border: d?.balanceAmount
                                        ? "1px solid rgba(233, 234, 240, 1)"
                                        : "",
                                      borderRadius: "12px",
                                      padding: "10px",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    <div className="emi-item">
                                      <div className="emi-names">
                                        <Checkbox
                                          checked={
                                            d?.isSelected || d?.autoSelected
                                          }
                                          disabled
                                          sx={{
                                            color: "#9CA3AF",
                                            "&.Mui-checked": {
                                              color: "#1dcd9e",
                                            },
                                          }}
                                          aria-disabled={d?.autoSelected}
                                        />
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "5px",
                                          }}
                                        >
                                          <div>
                                            {d?.emiName ||
                                              `EMI ${d?.emiNumber}`}{" "}
                                            :{" "}
                                          </div>
                                          <div>
                                            <span>
                                              {new Date(
                                                d?.dueDate
                                              ).toLocaleDateString("en-GB")}
                                            </span>
                                          </div>
                                          {d?.paymentStatus === "PARTIAL" ? (
                                            <div
                                              style={{
                                                padding: "2px 8px",
                                                background:
                                                  "rgba(26, 115, 232, 0.05)",
                                                borderRadius: "8px",
                                                color: "rgba(26, 115, 232, 1)",
                                              }}
                                            >
                                              Partial
                                            </div>
                                          ) : d?.paymentStatus === "OVERDUE" ? (
                                            <div
                                              style={{
                                                padding: "2px 8px",
                                                background:
                                                  "rgba(254, 243, 242, 1)",
                                                borderRadius: "8px",
                                                color: "rgba(231, 69, 58, 1)",
                                              }}
                                            >
                                              Overdue
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        style={{
                                          color: "#1dcd9e",
                                          fontWeight: "bold",
                                          fontSize: "18px",
                                        }}
                                      >
                                        {cartData?.branchDetail?.currency}
                                        {d?.emiAmount.toFixed(2)}
                                      </div>
                                    </div>

                                    {d?.balanceAmount > 0 && (
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          background: "#F9FAFB",
                                          padding: "8px 12px",
                                          marginTop: "6px",
                                          marginLeft: "36px",
                                          borderRadius: "10px",
                                        }}
                                      >
                                        <div className="emi-names">
                                          <Checkbox
                                            checked={d?.isBalanceSelected}
                                            onChange={() =>
                                              handleBalanceToggle(d.id)
                                            }
                                            sx={{
                                              color: "#9CA3AF",
                                              "&.Mui-checked": {
                                                color: "#1dcd9e",
                                              },
                                            }}
                                          />
                                          <div>Balance</div>
                                        </div>

                                        <div
                                          style={{
                                            color: "#1dcd9e",
                                            fontWeight: "bold",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {cartData?.branchDetail?.currency}
                                          {d?.balanceAmount.toFixed(2)}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          </>
                        )}
                        {cartData?.paymentCartData?.paymentType ===
                          "RANDOM_PAYMENT" && (
                          <div style={{ height: "200px", overflowY: "scroll" }}>
                            <div
                              style={{
                                padding: "10px",
                                color: "rgba(37, 36, 34, 1)",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Additional Payment
                            </div>
                            <div className="emi-item">
                              <div className="emi-names">
                                <div>
                                  {cartData?.additionalPaymentDetail
                                    ?.additionalPaymentName
                                    ? cartData?.additionalPaymentDetail
                                        ?.additionalPaymentName
                                    : "Additional Payment"}
                                </div>
                              </div>
                              <div
                                style={{
                                  color: "#1dcd9e",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {cartData?.branchDetail?.currency}
                                {cartData?.paymentCartData?.amount}
                              </div>
                            </div>
                          </div>
                        )}
                        {cartData?.paymentCartData?.paymentType ===
                          "REGULAR" && (
                          <div style={{ height: "200px", overflowY: "scroll" }}>
                            <div
                              style={{
                                padding: "10px",
                                color: "rgba(37, 36, 34, 1)",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Regular Payment
                            </div>
                            <div className="emi-item">
                              <div className="emi-names">
                                <div>Total</div>
                              </div>
                              <div
                                style={{
                                  color: "#1dcd9e",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {cartData?.branchDetail?.currency}
                                {cartData?.paymentCartData?.amount}
                              </div>
                            </div>
                          </div>
                        )}
                        {cartData?.paymentCartData?.paymentType ===
                          "WEBFORM" && (
                          <div style={{ height: "200px", overflowY: "scroll" }}>
                            <div
                              style={{
                                padding: "10px",
                                color: "rgba(37, 36, 34, 1)",
                                fontSize: "16px",
                                fontWeight: "600",
                              }}
                            >
                              Webform
                            </div>
                            <div className="emi-item">
                              <div className="emi-names">
                                <div>Total</div>
                              </div>
                              <div
                                style={{
                                  color: "#1dcd9e",
                                  fontWeight: "bold",
                                  fontSize: "18px",
                                }}
                              >
                                {cartData?.branchDetail?.currency}
                                {cartData?.paymentCartData?.amount}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="student-card">
                    <div
                      style={{
                        borderBottom: "1px solid rgba(233, 234, 240, 1)",
                        padding: "10px",
                        color: "rgba(37, 36, 34, 1)",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Student Details
                    </div>
                    <div className="student-card-details">
                      <div className="student-avatar">
                        {cartData?.enquiryDetail?.enquiryName?.charAt(0)}
                      </div>
                      <div>
                        <div className="student-name">
                          {cartData?.enquiryDetail?.enquiryName}
                        </div>
                        {/* <div className="student-details">
                  sidavlog@gmail.com | +91 9558545654
                </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                {/* RIGHT SIDE */}
                <div className="cart-right">
                  {/* Currency Box */}
                  <div className="currency-box">
                    {emiData?.length > 0 && (
                      <div className="price-from">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="label">From</div>
                          <div
                            style={{
                              border: "1px solid rgba(233, 234, 240, 1.2)",
                              borderRadius: "8px",
                              padding: "4px",
                              width: "50px",
                              textAlign: "center",
                            }}
                          >
                            {cartData?.branchDetail?.currency}
                          </div>
                        </div>
                        <h3>{`${cartData?.branchDetail?.currency} ${formatINR(
                          totalSelectedAmount
                        )}`}</h3>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div style={{ marginRight: "5px" }}>1</div>
                          <div>{cartData?.branchDetail?.currency}</div>
                          <div style={{ margin: "0px 5px" }}>=</div>
                          <div style={{ marginLeft: "5px" }}>
                            {(
                              1 /
                              cartData?.conversionRateDetail?.targetCurrencyRate
                            )?.toFixed(2)}
                          </div>
                          <div>INR</div>
                        </div>
                      </div>
                    )}
                    {(cartData?.paymentCartData?.paymentType ===
                      "RANDOM_PAYMENT" ||
                      "REGULAR") &&
                      emiData?.length === 0 && (
                        <div className="price-from">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="label">From</div>
                            <div
                              style={{
                                border: "1px solid rgba(233, 234, 240, 1.2)",
                                borderRadius: "8px",
                                padding: "4px",
                                width: "50px",
                                textAlign: "center",
                              }}
                            >
                              {cartData?.branchDetail?.currency}
                            </div>
                          </div>
                          <h3>{`${cartData?.branchDetail?.currency} ${
                            // cartData?.conversionRateDetail?.targetCurrencyRate *
                            formatINR(cartData?.paymentCartData?.amount)
                          }`}</h3>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div style={{ marginRight: "5px" }}>1</div>
                            <div> {cartData?.branchDetail?.currency}</div>
                            <div style={{ margin: "0px 5px" }}>{"="}</div>
                            <div style={{ marginLeft: "5px" }}>
                              {(
                                1 /
                                cartData?.conversionRateDetail
                                  ?.targetCurrencyRate
                              )?.toFixed(2)}{" "}
                            </div>
                            <div>INR</div>
                          </div>
                        </div>
                      )}
                    <div
                      style={{
                        position: "absolute",
                        right: "230px",
                        top: "320px",
                      }}
                    >
                      <img src={Currency} />
                    </div>
                    {emiData?.length > 0 && (
                      <div className="price-to">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="label">To</div>
                          <div
                            style={{
                              border: "1px solid rgba(233, 234, 240, 1.2)",
                              borderRadius: "8px",
                              padding: "4px",
                              width: "50px",
                              textAlign: "center",
                            }}
                          >
                            {"INR"}
                          </div>
                        </div>
                        <h3>
                          ₹{" "}
                          {formatINR(
                            (
                              totalSelectedAmount /
                              cartData?.conversionRateDetail?.targetCurrencyRate
                            ).toFixed(2)
                          )}
                        </h3>
                        <small>
                          1 INR ={" "}
                          {`${cartData?.branchDetail?.currency} ${cartData?.conversionRateDetail?.targetCurrencyRate}`}
                        </small>
                      </div>
                    )}
                    {(cartData?.paymentCartData?.paymentType ===
                      "RANDOM_PAYMENT" ||
                      "REGULAR") &&
                      emiData?.length === 0 && (
                        <div className="price-to">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div className="label">To</div>
                            <div
                              style={{
                                border: "1px solid rgba(233, 234, 240, 1.2)",
                                borderRadius: "8px",
                                padding: "4px",
                                width: "50px",
                                textAlign: "center",
                              }}
                            >
                              {"INR"}
                            </div>
                          </div>
                          <h3>
                            ₹{" "}
                            {/* {cartData?.conversionRateDetail?.INRCurrencyRate *
                              cartData?.paymentCartData?.amount} */}
                            {formatINR(
                              (
                                (1 /
                                  cartData?.conversionRateDetail
                                    ?.targetCurrencyRate) *
                                cartData?.paymentCartData?.amount
                              ).toFixed(2)
                            )}
                          </h3>
                          <small>
                            1 INR ={" "}
                            {`${
                              cartData?.branchDetail?.currency
                            } ${cartData?.conversionRateDetail?.targetCurrencyRate.toFixed(
                              2
                            )}`}
                          </small>
                        </div>
                      )}
                  </div>

                  {/* Order Summary */}
                  <div className="summary-card">
                    <h4>Order Summary</h4>
                    {/* <div className="summary-row">
                  <span>Subtotal</span>
                  <span>$133.59</span>
                </div>
                <div
                  className="summary-row"
                  style={{
                    borderBottom: "1px solid rgba(233, 234, 240, 1)",
                    paddingBottom: "10px",
                  }}
                >
                  <span>Taxes</span>
                  <span>2%</span>
                </div> */}

                    {emiData?.length > 0 && (
                      <div className="summary-total">
                        <span>Total:</span>
                        <span>{`${cartData?.branchDetail?.currency} ${formatINR(
                          totalSelectedAmount.toFixed(2)
                        )}`}</span>
                      </div>
                    )}
                    {emiData?.length > 0 && (
                      <div className="summary-total">
                        <span>Total In INR:</span>
                        <span>{`${"₹"} ${formatINR(
                          Number(
                            (1 /
                              cartData?.conversionRateDetail
                                ?.targetCurrencyRate) *
                              cartData?.paymentCartData?.amount || 0
                          ).toFixed(2)
                        )}`}</span>
                      </div>
                    )}
                    {(cartData?.paymentCartData?.paymentType ===
                      "RANDOM_PAYMENT" ||
                      "REGULAR") &&
                      emiData?.length === 0 && (
                        <div className="summary-total">
                          <span>Total:</span>
                          <span>{`${
                            cartData?.branchDetail?.currency
                          } ${formatINR(
                            (cartData?.paymentCartData?.amount) // cartData?.conversionRateDetail?.targetCurrencyRate *
                              .toFixed(2)
                          )}`}</span>
                        </div>
                      )}
                    {(cartData?.paymentCartData?.paymentType ===
                      "RANDOM_PAYMENT" ||
                      "REGULAR") &&
                      emiData?.length === 0 && (
                        <div className="summary-total">
                          <span>Total In INR:</span>
                          <span>{`${"₹"} ${formatINR(
                            Number(
                              (1 /
                                cartData?.conversionRateDetail
                                  ?.targetCurrencyRate) *
                                cartData?.paymentCartData?.amount || 0
                            ).toFixed(2)
                          )}`}</span>
                        </div>
                      )}
                    {
                      <button
                        className="pay-btn"
                        onClick={handleCompletePayment}
                      >
                        {loading ? (
                          <CircularProgress size={20} color={"inherit"} />
                        ) : (
                          "Complete Payment"
                        )}
                      </button>
                    }
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
      <ViewLeadCardPopUp
        open={open}
        title="You are being redirected to the Eazebuzz Payment page.Thank you."
      />
      <InvalidCart
        open={openInvalidCart}
        title="Cart is Invalid Please generate a new link.Thank you."
      />
    </div>
  );
};

export default PaymentCart;
